import { render, staticRenderFns } from "./VideoSmall.vue?vue&type=template&id=3c28d647&"
import script from "./VideoSmall.vue?vue&type=script&lang=js&"
export * from "./VideoSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports